module.exports = __webpack_public_path__ + "img/no-results.75e209a6.svg";